import React from "react";
import DensoLogo from "../../components/DensoLogo/DensoLogo";
import AuthViewLayout from "../../layouts/AuthViewLayout";
import HeadingContainer from "../../containers/HeadingContainer";
import { useIntl } from "react-intl";
import ForgotPasswordResetForm from "../../containers/ForgotPasswordResetForm";
import variables from "../../themes/base/styles/variables";

function ForgotPasswordResetFormView() {
  const intl = useIntl();
  const welcomeMessage = intl.formatMessage({ id: "login.createNewPassword" });

  return (
    <AuthViewLayout
      topSection={<DensoLogo />}
      topSectionStyle={{
        marginTop: variables.marginXLg,
      }}
      middleSection={
        <HeadingContainer
          level={2}
          heading={welcomeMessage}
        />
      }
      bottomSection={<ForgotPasswordResetForm />}
    />
  );
}

export default ForgotPasswordResetFormView;
